import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChatFastTrackResultCard, RuleActionExtension } from '@sabstravtech/obtservices/base';
import { formatCardCurrency, policyStatusClass, policyStatusLabel } from '../chat-card.util';

@Component({
  selector: 'app-chat-fast-track-card',
  standalone: false,
  templateUrl: './chat-fast-track-card.component.html',
  styleUrls: ['./chat-fast-track-card.component.scss']
})
export class ChatFastTrackCardComponent {
  @Input() card!: ChatFastTrackResultCard;
  @Output() cardClick = new EventEmitter<void>();

  get policyClass(): string {
    return policyStatusClass(this.card.policyStatus);
  }

  get policyLabel(): string {
    return policyStatusLabel(this.policyClass);
  }

  /** Quote's policy fields, shaped for `app-warning-tags` — the same
   *  indicator/tooltip component the results page uses, so the chat card and
   *  results page render identically instead of a bespoke text box. */
  get headlineWarningTicket(): RuleActionExtension {
    return {
      unavailable: !!this.card.unavailable,
      unavailableMessage: this.card.unavailableMessage || '',
      requiresReasonKeys: this.card.requiresReasonKeys || [],
      requiresReasonMessages: this.card.requiresReasonMessages || []
    };
  }

  /** Select the card unless the quote is out of policy and disallowed. */
  onCardClick(): void {
    if (this.card.unavailable) return;
    this.cardClick.emit();
  }

  get formattedPrice(): string {
    if (this.card.unavailable) {
      return '';
    }
    return formatCardCurrency(this.card.price, this.card.currency || 'GBP');
  }
}
